import Swal from "sweetalert2";
import { Button, TextField } from "@mui/material";
import { useState } from "react";
import { getUserData } from "../utils/userData";
import { createClass } from "../services/api";
import { AxiosError } from "axios";

export const AccessModal = ({
  open,
  onClose,
  onSuccess,
}: {
  open: boolean;
  onClose: () => void;
  onSuccess?: (classCode: string) => void;
}) => {
  const [code, setCode] = useState("");
  const [className, setClassName] = useState("");
  const { name, email, sub } = getUserData();

  const handleSubmit = async () => {
    try {
      const response = await createClass(code, sub, email, name, className, "");
      
      // 如果有 onSuccess 回調，使用它；否則顯示舊的 SweetAlert
      if (onSuccess) {
        // 直接關閉 AccessModal 並觸發成功回調
        setCode("");
        setClassName("");
        onClose();
        
        // 從 API 回應中獲取班級邀請碼（需要確認 API 回傳格式）
        const classCode = response.data?.classCode || response.data?.inviteCode || "UNKNOWN";
        onSuccess(classCode);
      } else {
        // 保持原有行為，顯示 SweetAlert
        Swal.fire({
          icon: "success",
          title: "成功",
          text: "班級建立成功",
          confirmButtonText: "確定",
          confirmButtonColor: "#2563eb",
        }).then(() => {
          setCode("");
          setClassName("");
        });
      }
    } catch (err: unknown) {
      
      if (err instanceof AxiosError) {
        
        if (err.response?.data.detail === "邀請碼已被使用") {
          Swal.fire({
            icon: "error",
            title: "失敗",
            text: "此邀請碼已被使用",
            confirmButtonText: "重新輸入",
          });
        } else if (err.response?.data.detail === "開通馬已過期") {
          Swal.fire({
            icon: "error",
            title: "失敗",
            text: "開通馬已過期，請聯絡管理員取得新的開通碼",
            confirmButtonText: "重新輸入",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "失敗",
            text: err.response?.data?.detail || "班級建立失敗",
            confirmButtonText: "繼續開通",
          });
        }
      }
    }
  };

  return (
    <div
      onClick={onClose}
      className={`fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-20 p-4 ${
        open ? "block" : "hidden"
      }`}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white p-6 md:p-10 rounded-lg flex flex-col gap-4 max-w-[460px] w-full max-h-[90vh] overflow-y-auto"
      >
        <div className="flex items-center justify-center p-4 bg-primary-light text-lg font-medium text-white rounded-sm">
          輸入教師開通碼
        </div>
        <div className="flex gap-4 flex-col">
          <TextField
            label="教師開通碼"
            variant="outlined"
            fullWidth
            sx={{ backgroundColor: "white" }}
            value={code}
            onChange={(e) => {
              const value = e.target.value;
              // 只允許數字，最多5位
              if (/^\d{0,5}$/.test(value)) {
                setCode(value);
              }
            }}
          />
          <TextField
            label="自訂班級名稱"
            variant="outlined"
            fullWidth
            sx={{ backgroundColor: "white" }}
            value={className}
            onChange={(e) => setClassName(e.target.value)}
          />
          <div className="text-sm text-gray-600 text-center">
            若需取得開通碼，請聯繫翰林業務為您協助
          </div>
          <Button
            onClick={handleSubmit}
            color="error"
            variant="contained"
            sx={{
              textWrap: "nowrap",
              px: "24px",
              maxWidth: "120px",
              mx: "auto",
              width: "100%",
            }}
            disabled={code === "" || className === ""}
          >
            送出
          </Button>
        </div>
      </div>
    </div>
  );
};